import {kSystemImages} from "../../../constants/images";

// METHODS
// ---- Render flash score emoji depending on success ratio
export function renderScoreEmoji(successRatio) {
    if (successRatio === 100) {
        return kSystemImages.starsFox
    } else if (successRatio >= 80) {
        return kSystemImages.blinkingFox
    } else if (successRatio >= 60) {
        return kSystemImages.happyFox
    } else if (successRatio >= 40) {
        return kSystemImages.scepticalFox
    } else if (successRatio >= 20) {
        return kSystemImages.confusedFox
    } else {
        return kSystemImages.confusedFox
    }
}

// ---- Render flash score emoji depending on success ratio
export function renderScoreIceEmoji(successRatio) {
    if (successRatio === 100) {
        return kSystemImages.starsFox
    } else if (successRatio >= 80) {
        return kSystemImages.blinkingFox
    } else if (successRatio >= 60) {
        return kSystemImages.happyFox
    } else if (successRatio >= 40) {
        return kSystemImages.scepticalFox
    } else if (successRatio >= 20) {
        return kSystemImages.confusedFox
    } else {
        return kSystemImages.confusedFox
    }
}